import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { ReactComponent as Coins } from "../../../assets/images/coins.svg";
import { ReactComponent as Wallet } from "../../../assets/images/wallet.svg";
import { ReactComponent as Bill } from "../../../assets/images/bill.svg";
import { numberFormat } from "../../../helpers/utils";
import { formatCurrencyExtended } from "../../../helpers/currencyFormatter";
import {
  SaleCard,
  SaleCardAdminLabel,
  SaleCardAdminMainValue,
  SaleCardAdminSecondaryValue,
  SaleCardsContainer,
} from "./financial.styles";
import { SocialFinancialDataModel } from "../../../types/indicators.interfaces";
import { SectionTitle } from "../../../styles/global.styles";

interface SocialFinancialCardsProps {
  social_financial: SocialFinancialDataModel[] | null;
  country?: string;
}

export function SocialFinancialCards({ social_financial, country = 'es' }: SocialFinancialCardsProps) {
  const intl = useIntl();
  
  return (
    <>
      <SectionTitle>
        {intl.formatMessage({ id: `financial.secondTitle` })}
      </SectionTitle>
      <SaleCardsContainer>
        {social_financial ? (
          <>
            {social_financial.map((item) => (
              <SaleCard key={item.id}>
                {getLogo(item.id)}
                <SaleCardAdminLabel>
                  <FormattedMessage id={`financial.${item.id}`} />
                </SaleCardAdminLabel>
                <SaleCardAdminMainValue>
                  {!item.value ? (
                    "-"
                  ) : (
                    <>
                      {getSocialFinancialValue(item.id, item.value, country)}
                    </>
                  )}
                </SaleCardAdminMainValue>
                <SaleCardAdminSecondaryValue>
                  <FormattedMessage id={`financial.${item.labelId}`} />
                </SaleCardAdminSecondaryValue>
              </SaleCard>
            ))}
          </>
        ) : (
          <SaleCardsContainer>
            {["averageRent", "affordability", "unemployment"].map((id) => (
              <SaleCard key={id}>
                {getLogo(id)}
                <SaleCardAdminLabel>
                  <FormattedMessage id={`financial.${id}`} />
                </SaleCardAdminLabel>
                <SaleCardAdminMainValue>-</SaleCardAdminMainValue>
                <SaleCardAdminSecondaryValue>
                  <FormattedMessage
                    id={`financial.${
                      id === "averageRent"
                        ? "byHouse"
                        : id === "affordability"
                        ? "years"
                        : "inZone"
                    }`}
                  />
                </SaleCardAdminSecondaryValue>
              </SaleCard>
            ))}
          </SaleCardsContainer>
        )}
      </SaleCardsContainer>
    </>
  );
}

function getSocialFinancialValue(key: string, value: number, country: string) {
  if (key === "averageRent") {
    return formatCurrencyExtended(value, country);
  } else if (key === "affordability") {
    return numberFormat.format(Math.round(value * 10) / 10);
  } else {
    return `${numberFormat.format(value)}%`;
  }
}

function getLogo(id: string) {
  if (id === "averageRent") {
    return <Coins />;
  } else if (id === "affordability") {
    return <Wallet />;
  } else if (id === "unemployment") {
    return <Bill />;
  }
} 